var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7243_37092)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0621 27.4722L10.9789 27.3237L10.8581 27.1998L10.6992 27.1006L10.593 27.0616L10.499 27.0417C10.2977 27.0643 10.0979 27.0821 9.89869 27.094C9.68501 27.1249 9.49299 27.0788 9.32299 26.9553C9.17396 26.8363 9.06405 26.6604 8.99354 26.4275L9.00596 26.4463C8.95735 26.3162 8.95042 26.1675 8.98594 26.0004C9.01255 25.8752 9.05402 25.7587 9.10943 25.6504L9.39134 25.1708C9.40609 25.152 9.41386 25.1154 9.41468 25.061L9.40529 24.7975C9.38958 24.7176 9.37365 24.6648 9.35704 24.6398L9.11612 24.6214C8.85896 24.5997 8.72553 24.5871 8.71494 24.5849C8.6292 24.5774 8.48429 24.5417 8.28029 24.4764C8.10756 24.4178 7.97316 24.3562 7.87748 24.2923L7.65935 24.1641L7.59109 24.1005L7.21749 24.6266C6.72194 25.3172 6.31502 25.8959 5.9978 26.3633L6.00025 26.4289L5.99685 26.4449L6.02486 26.4669L6.08742 26.4802L6.58256 26.5367C6.91062 26.5845 7.15357 26.647 7.3117 26.7247C7.59671 26.8723 7.79665 27.0349 7.9112 27.2119C8.03225 27.412 8.07897 27.6291 8.05112 27.8633L7.95804 28.3012C7.89969 28.474 7.86522 28.6086 7.85585 28.7048C8.00459 28.6714 8.15777 28.6437 8.31498 28.6225L9.36844 28.4374C9.99127 28.33 10.3516 28.2754 10.4498 28.2748L11.0878 28.1977L11.0911 28.1823C11.1181 27.8493 11.1084 27.6132 11.0621 27.4722ZM14.8246 24.8533C14.8562 25.0125 14.8575 25.1603 14.8287 25.2961C14.8044 25.4103 14.718 25.6105 14.5704 25.8955C14.4616 26.101 14.395 26.2341 14.371 26.2947C14.3341 26.4178 14.3223 26.5239 14.3358 26.6144C14.3353 26.6686 14.3513 26.7211 14.3842 26.7715L14.4391 26.898C14.5112 27.0223 14.6704 27.1437 14.9179 27.2615C15.2338 27.416 15.4017 27.5005 15.42 27.5154C15.5073 27.567 15.5829 27.6207 15.6471 27.6785L15.9335 27.6409C15.967 27.6372 16.2338 27.6121 16.7343 27.5657C17.0338 27.5421 17.2528 27.5124 17.3912 27.4767C17.5213 27.4278 17.6015 27.3847 17.6313 27.3474L17.6546 27.2379L17.6353 27.0211L17.5599 26.7598C17.5174 26.6525 17.4744 26.5725 17.431 26.5197C17.3306 26.324 17.2265 26.1491 17.1171 25.9953C16.9564 25.7756 16.7112 25.467 16.3812 25.0697L14.9517 23.4085C14.3614 22.7485 13.9589 22.2814 13.7444 22.0069C13.446 21.6163 13.1778 21.1834 12.941 20.7075C12.2927 19.2938 11.8642 18.3086 11.6554 17.752L11.4888 17.2258L11.8352 17.6754C12.2094 18.2237 12.7675 19.1383 13.509 20.4194C13.8294 20.9132 14.1147 21.2898 14.3649 21.5501C14.5504 21.7531 14.9725 22.1807 15.6295 22.833L17.1574 24.4173C17.5744 24.8661 17.8582 25.1989 18.0084 25.416C18.1136 25.5369 18.2556 25.7414 18.4339 26.0302C18.6097 26.3837 18.7121 26.6455 18.7414 26.8153C18.7828 27.0312 18.8018 27.1988 18.7981 27.318L18.7539 27.6031C18.7553 27.647 18.7229 27.749 18.6561 27.9095L18.4677 28.1799L18.2109 28.3874C18.0595 28.4857 17.89 28.5645 17.7032 28.6227C17.4597 28.6909 17.1703 28.744 16.8351 28.782C16.3113 28.8342 16.0379 28.8631 16.015 28.8695L8.55438 30.0314C7.54802 30.1993 6.76963 30.2956 6.21935 30.3203C5.68126 30.3368 5.23929 30.3138 4.89249 30.2509C4.59007 30.1866 4.32652 30.0924 4.10198 29.9684C3.94636 29.8804 3.80647 29.7689 3.68236 29.6339L3.50328 29.3992L3.36539 29.1245C3.31143 28.9165 3.28987 28.7103 3.30045 28.5052L3.38228 28.0481L3.66385 27.3392C3.84436 26.9519 4.073 26.5425 4.3503 26.1108C4.69132 25.5836 5.23425 24.7993 5.97901 23.758L9.09255 18.4984C9.22713 18.2761 9.52709 17.8654 9.99227 17.2666C10.1902 17.0031 10.3377 16.8218 10.435 16.7228C10.5748 16.5778 10.7264 16.5063 10.8895 16.5086C11.0525 16.5109 11.1663 16.6437 11.2299 16.9081C11.2728 17.1682 11.2409 17.4722 11.1342 17.8202C11.0537 18.0975 10.9296 18.3983 10.7624 18.7226C10.7477 18.7411 10.629 18.9396 10.4069 19.318C10.3944 19.3261 10.3103 19.4663 10.154 19.7383L10.2032 19.8144C10.2923 19.9093 10.405 19.9934 10.5422 20.0662C10.7354 20.1838 11.0598 20.3505 11.5153 20.5675C11.9744 20.8179 12.2691 21.1258 12.3986 21.4913C12.5018 21.7753 12.5109 22.1694 12.4254 22.6747C12.3411 23.0716 12.3025 23.3303 12.309 23.4517C12.3259 23.6296 12.4099 23.7729 12.5616 23.8813C12.6068 23.924 12.6662 23.9524 12.7394 23.9679L13.0467 23.9845C13.5383 23.98 13.7999 23.981 13.8309 23.9876C14.0293 24.0298 14.1771 24.0776 14.2748 24.1307L14.4738 24.2715L14.6317 24.4519C14.7266 24.5707 14.7908 24.7041 14.8246 24.8533Z",
    fill: "url(#paint0_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3595 9.37543C33.5434 9.72581 32.6317 10.2459 31.6231 10.9367C31.0472 11.3373 30.3222 11.8762 29.4478 12.5517C27.8366 13.7691 26.6856 14.5926 25.9943 15.024C25.3428 15.4198 24.4576 15.9678 23.3384 16.6677L22.3104 17.3489L21.5527 17.989C20.8502 18.6252 20.3367 19.0666 20.0116 19.3139C19.8429 19.4416 19.7486 19.5249 19.7294 19.5643L19.792 19.5776C19.867 19.5827 19.9729 19.5725 20.1092 19.5472C20.5709 19.4268 21.2031 19.1195 22.006 18.6251L23.8448 17.5928C24.4888 17.2826 25.4202 16.7991 26.6397 16.1422C27.5363 15.6678 28.766 14.86 30.3277 13.7198C31.6256 12.7964 32.3377 12.2934 32.4644 12.2111C33.4889 11.5458 34.3327 11.065 34.9954 10.7701C35.1763 10.6884 35.3619 10.5584 35.5524 10.3811C35.8082 10.1518 35.8941 9.90311 35.8093 9.63449C35.7166 9.35302 35.4862 9.20597 35.1179 9.19308C34.9445 9.18903 34.6918 9.24947 34.3595 9.37543Z",
    fill: "url(#paint1_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1169 20.9722C20.1892 20.889 20.2372 20.8174 20.261 20.7574L20.2617 20.6759C20.2083 20.6207 20.0996 20.592 19.9364 20.59C19.4196 20.611 18.8856 20.7376 18.3348 20.9696C18.2423 20.9934 18.2594 21.144 18.3855 21.422C18.5145 21.6893 18.6102 21.8021 18.6736 21.7613C19.4871 21.4216 19.9683 21.1585 20.1169 20.9722Z",
    fill: "url(#paint2_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.605 19.898C21.5357 19.9161 21.5539 20.0615 21.6593 20.3349C21.7878 20.602 21.8709 20.7233 21.9096 20.6985C22.4262 20.5247 22.774 20.3261 22.9524 20.1023C23.0096 20.0378 23.0449 19.9746 23.0582 19.9121L23.0555 19.8464C23.0251 19.785 22.9419 19.7405 22.8061 19.7116C22.5136 19.6495 22.1137 19.7116 21.605 19.898Z",
    fill: "#E1DEF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8034 19.0566C26.8863 18.9761 26.9393 18.9055 26.9632 18.8452L26.9797 18.767C26.9385 18.7036 26.8257 18.6685 26.6418 18.6621C26.5877 18.6614 26.3937 18.6751 26.0608 18.7022L24.9907 18.9655C24.8985 18.9897 24.8996 19.1371 24.9948 19.4083C25.0922 19.6688 25.1818 19.786 25.2637 19.7596C26.1013 19.5129 26.6144 19.2782 26.8034 19.0566Z",
    fill: "url(#paint3_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.526 18.0976L29.5427 18.0194C29.5249 17.9505 29.4711 17.8949 29.3815 17.8543C29.1212 17.7447 28.7872 17.777 28.3792 17.9524C28.3413 17.9767 28.3772 18.1155 28.4872 18.3675C28.5994 18.6093 28.6814 18.736 28.7337 18.7471C29.1209 18.5679 29.3561 18.4106 29.4392 18.2754C29.4837 18.2195 29.5127 18.1602 29.526 18.0976Z",
    fill: "url(#paint4_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1148 22.2801C21.1012 22.5501 21.1462 22.6957 21.2507 22.7179C22.0016 22.7249 22.5812 22.6409 22.9892 22.4654C23.0986 22.4128 23.1806 22.3592 23.2359 22.3055L23.2649 22.2463C23.2489 22.1668 23.1494 22.0965 22.966 22.0359C22.6849 21.9212 22.1146 21.8603 21.2549 21.8519C21.161 21.8319 21.1144 21.9745 21.1148 22.2801Z",
    fill: "url(#paint5_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3802 22.8273C25.6225 22.8679 25.864 22.8862 26.1045 22.8827C26.2654 22.8954 26.4515 22.8914 26.663 22.8709L27.0685 22.8099L27.3367 22.7032C27.4567 22.6526 27.5396 22.5936 27.5867 22.5277L27.619 22.4528C27.5906 22.3807 27.4837 22.32 27.2981 22.2698L25.4816 21.9655C25.3764 21.9977 25.309 22.1359 25.2787 22.38C25.242 22.6559 25.2757 22.805 25.3802 22.8273Z",
    fill: "url(#paint6_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.99 22.5974C30.9821 22.53 30.9099 22.4603 30.7725 22.3876C30.4982 22.2416 30.0347 22.1646 29.3823 22.1575C29.3131 22.1752 29.282 22.3214 29.2891 22.5958C29.2856 22.8676 29.3256 23.0125 29.4091 23.0302C30.0537 23.0252 30.5109 22.9536 30.7803 22.8143C30.8664 22.7674 30.9256 22.7198 30.9574 22.6722L30.99 22.5974Z",
    fill: "#E1DEF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8192 22.38C33.5284 22.2089 33.147 22.1553 32.6755 22.2187C32.6063 22.2364 32.5911 22.3859 32.6292 22.667C32.6492 22.9329 32.6852 23.0714 32.7371 23.0824C33.2863 23.014 33.6379 22.9251 33.7916 22.8159C33.8676 22.7665 33.9217 22.7179 33.9535 22.67L33.9859 22.5951C33.9807 22.5177 33.9249 22.446 33.8192 22.38Z",
    fill: "url(#paint7_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2034 24.5736C18.2769 24.7417 18.4229 24.9254 18.6423 25.1249L18.8541 25.2841L19.0476 25.3743C19.216 25.4535 19.3859 25.5005 19.5571 25.5153C19.7202 25.5176 19.8242 25.4903 19.8688 25.4344C19.8947 25.3633 19.8612 25.2636 19.7689 25.1348L19.4532 24.7735C19.2008 24.5236 19.0494 24.3386 18.9985 24.2192C18.982 24.1937 18.8353 24.2172 18.5583 24.2892C18.2897 24.3737 18.1714 24.4683 18.2034 24.5736Z",
    fill: "url(#paint8_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.91 26.8493C21.8248 26.6345 21.5776 26.386 21.169 26.1029C21.0957 26.0873 20.9962 26.1974 20.8702 26.4316C20.7186 26.6831 20.6688 26.8144 20.721 26.8255C21.113 27.0835 21.4338 27.2169 21.6827 27.2262C21.8141 27.2218 21.8974 27.1901 21.9316 27.1323C21.9679 27.0631 21.9608 26.969 21.91 26.8493Z",
    fill: "#E1DEF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3638 29.0881C23.464 29.0771 23.5419 29.0442 23.5971 28.9909C23.6337 28.9221 23.6503 28.8438 23.6471 28.7559C23.6524 28.6802 23.6231 28.5873 23.5596 28.4753L23.4139 28.3137C23.3521 28.246 23.2669 28.1846 23.1587 28.1289C23.1172 28.1201 23.0425 28.2403 22.9348 28.4903C22.8215 28.7168 22.7653 28.852 22.7667 28.8962C23.0204 29.0368 23.219 29.1013 23.3638 29.0881Z",
    fill: "url(#paint9_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7861 25.9875C27.0927 25.7092 26.5909 25.5047 26.2809 25.3731L23.9045 24.3943C23.1817 24.099 22.5914 23.875 22.133 23.7233L20.9175 23.2849C20.3803 23.0945 19.9789 22.9817 19.7137 22.9473L19.4691 22.944L19.5889 23.1498C19.7619 23.361 20.0851 23.6367 20.558 23.9774L23.36 25.5705C23.9087 25.8615 24.2582 26.0395 24.408 26.1043L25.6967 26.7378C26.0047 26.8792 26.4935 27.0924 27.1636 27.3768C27.7403 27.641 28.2349 27.9042 28.648 28.1663C29.0029 28.3944 29.3448 28.3251 29.6734 27.9592C29.8707 27.7503 29.9195 27.5208 29.8199 27.2704C29.7489 27.0917 29.6405 26.9597 29.4951 26.8742C28.9738 26.5563 28.4039 26.2608 27.7861 25.9875Z",
    fill: "#E1DEF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8496 17.1532C19.8638 17.0359 19.8566 16.9417 19.8279 16.8705L19.791 16.8136L19.7061 16.8282C19.6368 16.8463 19.5567 16.8891 19.466 16.9575L19.0375 17.3571C18.6709 17.7477 18.4173 18.0432 18.2769 18.242C18.2546 18.3465 18.3496 18.4642 18.5613 18.5969C18.7708 18.7393 18.9137 18.786 18.9895 18.737C19.5577 17.9633 19.8442 17.4353 19.8496 17.1532Z",
    fill: "#E1DEF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8605 14.2923C21.8724 14.1859 21.8683 14.1032 21.8482 14.0443L21.8141 13.9716C21.8038 13.9694 21.7821 13.9701 21.7482 13.974C21.6813 13.9812 21.5983 14.0127 21.4992 14.0682C21.236 14.2302 20.89 14.6258 20.4622 15.2546C20.4025 15.3293 20.505 15.4381 20.7686 15.5815C21.0097 15.7311 21.1534 15.7725 21.2002 15.7059C21.6051 15.0834 21.8256 14.612 21.8605 14.2923Z",
    fill: "url(#paint10_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.843 11.7527C23.8527 11.6564 23.8422 11.5779 23.8114 11.5167L23.7711 11.4749C23.7505 11.4705 23.7233 11.4703 23.6895 11.4742C23.6249 11.4714 23.5504 11.4882 23.4664 11.5247L23.3179 11.6079L23.1025 11.7745L22.6987 12.2124L22.5325 12.4554C22.4729 12.5298 22.5764 12.6335 22.8423 12.7666C23.1188 12.9017 23.2628 12.943 23.2739 12.8911L23.3954 12.7042L23.7998 11.9559L23.843 11.7527Z",
    fill: "#E1DEF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5466 8.43498C25.5386 8.4222 25.5179 8.4178 25.4841 8.42168C25.4195 8.41872 25.3385 8.43952 25.242 8.48482C24.9219 8.65619 24.6146 9.04921 24.3206 9.66265C24.3029 9.7462 24.4125 9.84574 24.6496 9.96185C24.9284 10.0862 25.0757 10.112 25.0912 10.039C25.3593 9.496 25.5276 9.06289 25.5964 8.73958C25.6057 8.64349 25.6006 8.56583 25.5804 8.50722L25.5466 8.43498Z",
    fill: "url(#paint11_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1915 18.7477C15.3969 18.5509 15.4833 18.4276 15.4505 18.3771C15.2637 18.0757 15.1289 17.8615 15.0469 17.7351C14.9446 17.5498 14.8405 17.424 14.7346 17.3576C14.6495 17.2961 14.5756 17.2588 14.513 17.2455L14.4317 17.2449L14.3871 17.3008C14.3551 17.3483 14.3354 17.4148 14.3282 17.5009C14.3177 17.6512 14.3314 17.8177 14.3689 18.0003C14.4279 18.34 14.5641 18.6471 14.7786 18.9214C14.853 18.9809 14.9907 18.9229 15.1915 18.7477Z",
    fill: "#E1DEF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0787 15.8123L13.9271 15.3711C13.8495 15.2234 13.7837 15.1221 13.73 15.0672L13.5564 14.8834L13.3852 14.7652C13.3164 14.7287 13.2539 14.7154 13.1975 14.7253L13.1282 14.7433L13.08 14.8148C13.0565 14.875 13.0474 14.944 13.0528 15.0217L13.0662 15.1881C13.0757 15.2988 13.0882 15.3675 13.1045 15.3925L13.2598 16.0472C13.2465 16.1097 13.3913 16.0971 13.6934 16.0085C13.9912 15.9406 14.1199 15.8754 14.0787 15.8123Z",
    fill: "url(#paint12_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7324 12.5484L11.6912 12.5888C11.6485 12.634 11.6207 12.6879 11.6079 12.751C11.5798 12.8321 11.5783 12.941 11.6039 13.0773L11.6982 13.326C11.7324 13.4206 11.7972 13.5272 11.8921 13.6453C11.9249 13.696 12.0494 13.6244 12.265 13.4304L12.5638 13.1014C12.3203 12.8098 12.129 12.6327 11.9894 12.5704C11.9287 12.5467 11.8664 12.5335 11.8016 12.5304L11.7324 12.5484Z",
    fill: "url(#paint13_linear_7243_37092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7062 10.2044C18.7847 9.27206 18.8359 8.6722 18.8597 8.40506C18.8804 8.25663 18.852 8.10861 18.7741 7.96159C18.6552 7.75114 18.4525 7.62626 18.1667 7.58713C17.8805 7.54793 17.6568 7.62604 17.4954 7.82069C17.4041 7.94293 17.3459 8.0886 17.3208 8.25758C17.2791 8.60889 17.2401 9.22775 17.2046 10.114L16.988 14.2882C16.9478 14.8357 16.9151 15.4775 16.8895 16.2137C16.8901 16.8244 16.8996 17.268 16.917 17.5446C16.9917 18.4767 17.0932 18.9724 17.2224 19.0326C17.342 18.9821 17.4869 18.5054 17.6569 17.604C17.7596 17.2221 17.8443 16.7988 17.9104 16.3328L18.2595 14.4606L18.7062 10.2044Z",
    fill: "url(#paint14_linear_7243_37092)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7243_37092",
    x1: 1.13271,
    y1: 33.9585,
    x2: 22.8273,
    y2: 31.1087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7243_37092",
    x1: 18.0218,
    y1: 23.2999,
    x2: 37.9417,
    y2: 20.6105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7243_37092",
    x1: 17.9356,
    y1: 22.0622,
    x2: 20.5341,
    y2: 21.4917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7243_37092",
    x1: 24.5829,
    y1: 20.0507,
    x2: 27.2229,
    y2: 19.3898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7243_37092",
    x1: 28.0876,
    y1: 18.9231,
    x2: 29.7397,
    y2: 18.6452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7243_37092",
    x1: 20.7933,
    y1: 22.9406,
    x2: 23.2707,
    y2: 21.8664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7243_37092",
    x1: 24.9808,
    y1: 23.0319,
    x2: 27.3837,
    y2: 21.7327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7243_37092",
    x1: 32.3152,
    y1: 23.2922,
    x2: 34.1969,
    y2: 22.8061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7243_37092",
    x1: 17.8656,
    y1: 25.5244,
    x2: 20.2506,
    y2: 24.8167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7243_37092",
    x1: 22.6356,
    y1: 29.2365,
    x2: 23.8856,
    y2: 29.1079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7243_37092",
    x1: 20.192,
    y1: 16.1164,
    x2: 21.9836,
    y2: 16.1048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7243_37092",
    x1: 24.0897,
    y1: 10.419,
    x2: 25.6937,
    y2: 10.4199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7243_37092",
    x1: 12.667,
    y1: 16.357,
    x2: 14.4392,
    y2: 16.1858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7243_37092",
    x1: 11.3014,
    y1: 13.864,
    x2: 12.787,
    y2: 13.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7243_37092",
    x1: 14.2669,
    y1: 21.8992,
    x2: 17.7748,
    y2: 22.3927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7243_37092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(7.55859 0.709229) rotate(12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/party.7bacd57779e3b1289636a463c890ddb8.svg";
export { ForwardRef as ReactComponent };